import script from "./IngaPortrait.vue?vue&type=script&setup=true&lang=js"
export * from "./IngaPortrait.vue?vue&type=script&setup=true&lang=js"

import "./IngaPortrait.vue?vue&type=style&index=0&id=22ddc9a8&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22ddc9a8"]])

export default __exports__